import { createAction, props } from '@ngrx/store';

import { Notification } from '@shared/models';
import { Pagination } from '@shared/pagination';
import { ApiParams } from '@shared/services/api.service';

export const notificationsLoadPage = createAction(
  '[Notifications] Notifications load page',
  props<{ apiParams?: ApiParams }>(),
);

export const notificationsLoadPageSuccess = createAction(
  '[Notifications] Notifications load page success',
  props<{ page: Pagination<Notification> }>(),
);

export const notificationsUpdateAnonymizedNames = createAction(
  '[Notifications] Notifications Update Anonymized Names',
  props<{ isAnonymized: boolean }>(),
);

export const notificationsUpdateAnonymizedNamesSuccess = createAction(
  '[Notifications] Notifications Update Anonymized Names Success',
  props<{ notifications: Notification[] }>(),
);

export const notificationsLoadPageFail = createAction(
  '[Notifications] Notifications load page fail',
  props<{ error: any }>(),
);

/**
 * This action should notify the server to mark notifications as read
 * when they have been displayed to the user.
 * All notifications older that sent date will be treated as read.
 */
export const notificationsMarkAsRead = createAction('[Notifications] Mark notifications as read');

export const notificationsGetNewNotificationsCount = createAction(
  '[Notifications] Notifications get new notifications count',
);

export const notificationsGetNewNotificationsCountSuccess = createAction(
  '[Notifications] Notifications get new notifications count success',
  props<{ count: number }>(),
);

export const notificationsGetNewNotificationsCountFail = createAction(
  '[Notifications] Notifications get new notifications count fail',
  props<{ error: any }>(),
);

export const notificationsAddNew = createAction(
  '[Notifications] Notifications add new',
  props<{ notification: Notification }>(),
);

export const notificationsClear = createAction('[Notifications] Notifications clear');

export const hideNotification = createAction(
  '[Notifications] Notifications hide for user',
  props<{ notificationId: number }>(),
);
